"use client"
import React from "react";
import ReactHtmlParser from 'react-html-parser';
import { theme } from '@/components/features/theme/theme';

const LargeHeading = ({ text, textColor = "#2f3237" }) => {
    const textStyle = {
        fontFamily: theme.fonts.body,
        fontWeight: 500,
        fontSize: "15.625rem", // 200px assuming 1rem = 20px
        lineHeight: "100%", // 161px assuming 1rem = 20px
        letterSpacing: "-0.05em",
        color: textColor,
        textAlign: "center",

    };

    return <h3 className={'largeHeader paragraph'} data-scroll data-scroll-repeat style={textStyle}>{ReactHtmlParser(text)}</h3>;
};

export default LargeHeading;
